/** Misma ruta de fallback usada en catálogo / Inventario Fulfil (product-box-two, PDP). */
export const PRODUCT_IMAGE_PLACEHOLDER = 'assets/images/product/placeholder.jpg';
